import React from 'react';

import { VideoTutorielViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import BaseSelect from 'components/BaseForm/Select/BaseSelect';
import { FormInputProps } from 'components/BaseForm/types';
import { profileEnumMapping } from 'utils/enumData';

import BaseModalEdition from '../../Modals/ModalEdition/ModalEdition';
import { profilesOptions, VideoFormValue } from '../utils/type';

interface ModalEditionProps {
  close: () => void;
  visible: boolean;
  initials: VideoFormValue;
  title: string;
  submit: (values: VideoFormValue) => void;
  isSubmitting: boolean;
  validate: (
    field: VideoTutorielViolationDtoFormFieldEnum,
    values: VideoFormValue,
  ) => Promise<void>;
}

function ModalEdition({ ...props }: ModalEditionProps): React.ReactElement {
  const inputs: Array<
    FormInputProps<VideoFormValue, VideoTutorielViolationDtoFormFieldEnum>
  > = [
    {
      name: 'profile',
      label: 'Profil',
      field: VideoTutorielViolationDtoFormFieldEnum.PROFILE,
      required: true,
      render: () => {
        return (
          <BaseSelect
            options={profilesOptions}
            getOptionValue={option => option}
            getOptionLabel={options => profileEnumMapping[options].name}
            allowClear
          />
        );
      },
    },
    {
      name: 'videoId',
      label: 'YouTube ID',
      field: VideoTutorielViolationDtoFormFieldEnum.VIDEO_ID,
      required: true,
    },
  ];

  return <BaseModalEdition {...props} inputs={inputs} />;
}

export default ModalEdition;
